import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class StatsService {
  public onStatsChange: BehaviorSubject<{
    last_step_counter: { step: number; step_counter: number }[];
    total_step_counter: { step: number; step_counter: number }[];
  }>;

  constructor(private _httpClient: HttpClient) {
    this.onStatsChange = new BehaviorSubject(null);
  }

  getStats(from: string, to: string, recruiter: string) {
    return this._httpClient.get(`/request/step-counter/${from}/${to}/${recruiter}`);
  }

  getCommercialStats(from: string, to: string) {
    return this._httpClient.get(`/request/commercial-statistic/${from}/${to}`);
  }
}
